import React, { useEffect, useState } from 'react';
import api from '../api';

const CATEGORIES = [
  { id: 1, name: 'Гриль', slug: 'grill' },
  { id: 2, name: 'Гарячі страви', slug: 'hot' },
  { id: 12, name: 'Перші страви', slug: 'first-courses' },
  { id: 3, name: 'Холодні закуски', slug: 'cold' },
  { id: 11, name: 'Салати', slug: 'salads' },
  { id: 4, name: 'Дитяче меню', slug: 'kids' },
  { id: 5, name: 'Гарніри', slug: 'garnir' },
  { id: 6, name: 'Десерти', slug: 'dessert' },
  { id: 7, name: 'Гарячі напої ☕', slug: 'hot-drinks' },
  { id: 9, name: 'Бар - Алкогольні 🍾', slug: 'bar-alco' },
  { id: 10, name: 'Бар - Безалкогольні 🍹', slug: 'bar-nonalco' },
  { id: 8, name: 'Ланчі', slug: 'lanch' },
];
const BADGES = ['', 'new', 'hot', 'rec'];
const BADGE_LABELS = { '': 'Без бейджа', new: 'Новинка', hot: 'Гостра', rec: 'Рекомендовано' };

const DAYS = ['Понеділок', 'Вівторок', 'Середа', 'Четвер', "П'ятниця", 'Субота', 'Неділя'];

const empty = { name: '', description: '', price: '', discount_price: '', weight: '', category_id: 1, emoji: '🍽', badge: '', is_active: true, is_weight: false, is_preorder: false };

export default function DishesPage() {
  const [dishes, setDishes]       = useState([]);
  const [loading, setLoading]     = useState(true);
  const [modal, setModal]         = useState(false);
  const [form, setForm]           = useState(empty);
  const [editId, setEditId]       = useState(null);
  const [image, setImage]         = useState(null);
  const [saving, setSaving]       = useState(false);
  const [filter, setFilter]       = useState('all');
  const [search, setSearch]       = useState('');
  const [currentImage, setCurrentImage] = useState(null); // поточне фото страви, що редагується
  const [removeImage, setRemoveImage]   = useState(false); // позначка "видалити фото"
  const [previewUrl, setPreviewUrl]     = useState(null);  // прев'ю щойно вибраного файлу

  // Прев'ю нового файлу (з очищенням, щоб не було витоків пам'яті)
  useEffect(() => {
    if (!image) { setPreviewUrl(null); return; }
    const url = URL.createObjectURL(image);
    setPreviewUrl(url);
    return () => URL.revokeObjectURL(url);
  }, [image]);

  const load = () => {
    api.get('/dishes').then(r => setDishes(r.data)).finally(() => setLoading(false));
  };
  useEffect(load, []);

  const openAdd = () => { setForm(empty); setEditId(null); setImage(null); setCurrentImage(null); setRemoveImage(false); setModal(true); };
  
  const openEdit = (d) => {
    setForm({
      name: d.name, 
      description: d.description, 
      price: d.price,
      discount_price: d.discount_price || '',
      weight: d.weight || '', 
      category_id: d.category_id, 
      emoji: d.emoji,
      badge: d.badge || '', 
      is_active: d.is_active,
      is_weight: d.is_weight || false,
      is_preorder: d.is_preorder || false 
    });
    setEditId(d.id); setImage(null); setCurrentImage(d.image_url || null); setRemoveImage(false); setModal(true);
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      const fd = new FormData();
      Object.entries(form).forEach(([k, v]) => fd.append(k, v));
      if (image) fd.append('image', image);
      if (editId && removeImage && !image) fd.append('remove_image', 'true');

      if (editId) await api.put(`/dishes/${editId}`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      else await api.post('/dishes', fd, { headers: { 'Content-Type': 'multipart/form-data' } });

      setModal(false); load();
    } catch (err) {
      alert(err.response?.data?.error || 'Помилка');
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Видалити страву?')) return;
    await api.delete(`/dishes/${id}`);
    load();
  };

  const inputStyle = {
    width: '100%', padding: '10px 13px',
    border: '1px solid var(--border)', borderRadius: 8,
    fontSize: 13, background: '#fff', outline: 'none',
    fontFamily: 'inherit'
  };

  const filtered = dishes.filter(d => {
    const matchCategory = filter === 'all' || String(d.category_id) === String(filter);
    const searchLower = search.toLowerCase();
    const matchSearch = !search || 
                        d.name.toLowerCase().includes(searchLower) || 
                        (d.description || '').toLowerCase().includes(searchLower);
    
    return matchCategory && matchSearch;
  });

  const isLunch = String(form.category_id) === '8';

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 24 }}>
        <div>
          <div style={{ fontFamily: "'Fraunces', serif", fontSize: 28, fontWeight: 400 }}>Страви</div>
          <div style={{ fontSize: 13, color: 'var(--stone)', marginTop: 4, fontWeight: 300 }}>
            {dishes.length} позицій у меню
          </div>
        </div>
        <button onClick={openAdd} style={{
          background: 'var(--ink)', color: '#fff', border: 'none',
          borderRadius: 10, padding: '10px 20px', fontSize: 13, fontWeight: 500,
          cursor: 'pointer', transition: 'background 0.15s'
        }}>
          + Додати страву
        </button>
      </div>

      <div style={{ marginBottom: 16 }}>
        <input 
          type="text" 
          placeholder="Пошук за назвою або описом..." 
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{
            width: '100%', maxWidth: '400px', padding: '12px 16px',
            border: '1px solid var(--border)', borderRadius: 12,
            fontSize: 14, outline: 'none', fontFamily: 'inherit',
            boxShadow: '0 2px 8px rgba(0,0,0,0.02)',
            transition: 'border-color 0.2s'
          }}
          onFocus={e => e.target.style.borderColor = 'var(--ink)'}
          onBlur={e => e.target.style.borderColor = 'var(--border)'}
        />
      </div>

      <div style={{ display: 'flex', gap: 8, marginBottom: 20, flexWrap: 'wrap' }}>
        {[{ id: 'all', name: 'Всі' }, ...CATEGORIES].map(c => (
          <button key={c.id} onClick={() => setFilter(c.id)} style={{
            padding: '6px 14px', borderRadius: 20, fontSize: 12,
            border: '1px solid',
            borderColor: filter === c.id ? 'var(--ink)' : 'var(--border)',
            background: filter === c.id ? 'var(--ink)' : 'transparent',
            color: filter === c.id ? '#fff' : 'var(--stone)',
            transition: 'all 0.15s', cursor: 'pointer',
          }}>{c.name}</button>
        ))}
      </div>

      {loading ? (
        <div style={{ color: 'var(--stone)', padding: '40px 0', textAlign: 'center' }}>Завантаження...</div>
      ) : (
        <div style={{ background: '#fff', borderRadius: 16, border: '1px solid var(--border)', overflowX: 'auto' }}>
          <table style={{ width: '100%', minWidth: 800, borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: 'var(--paper)', borderBottom: '1px solid var(--border)' }}>
                {['Страва', 'Категорія', 'Ціна / Акція', 'Статус', 'Дії'].map(h => (
                  <th key={h} style={{ padding: '12px 16px', textAlign: 'left', fontSize: 11, color: 'var(--stone)', fontWeight: 500, letterSpacing: '1px', textTransform: 'uppercase' }}>
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filtered.length === 0 ? (
                <tr><td colSpan={5} style={{ padding: '40px', textAlign: 'center', color: 'var(--stone)' }}>
                  {search ? 'За вашим запитом нічого не знайдено 🔍' : 'Страв не знайдено'}
                </td></tr>
              ) : (
                filtered.map((d, i) => (
                  <tr key={d.id} style={{ borderBottom: i < filtered.length - 1 ? '1px solid var(--border)' : 'none' }}>
                    <td style={{ padding: '12px 16px', display: 'flex', alignItems: 'center', gap: 10 }}>
                      <div style={{ width: 36, height: 36, background: 'var(--sand2)', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18, flexShrink: 0, overflow: 'hidden' }}>
                        {d.image_url ? <img src={d.image_url.startsWith('http') ? d.image_url : `https://restaurant-backend-pi-nine.vercel.app${d.image_url}`} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : d.emoji}
                      </div>
                      <div>
                        <div style={{ fontSize: 13, fontWeight: 500, color: 'var(--ink)' }}>
                          {d.name} 
                          {d.is_preorder && <span style={{ color: '#d32f2f', fontSize: 11, marginLeft: 4 }} title="Передзамовлення">⏰</span>}
                        </div>
                        <div style={{ fontSize: 11, color: 'var(--stone)' }}>{(d.description || '').slice(0, 40)}...</div>
                      </div>
                    </td>
                    <td style={{ padding: '12px 16px', fontSize: 12, color: 'var(--stone)' }}>
                      {CATEGORIES.find(c => c.id === d.category_id)?.name || 'Невідомо'}
                    </td>
                    <td style={{ padding: '12px 16px', fontFamily: "'Fraunces', serif", fontSize: 14, color: 'var(--ink)' }}>
                      {d.discount_price ? (
                        <span>
                          <span style={{ textDecoration: 'line-through', color: '#999', marginRight: 6 }}>{d.price}₴</span>
                          <span style={{ color: '#e74c3c', fontWeight: 600 }}>{d.discount_price}₴</span>
                        </span>
                      ) : (
                        <span>{d.price} ₴</span>
                      )}
                      
                      {d.weight ? (
                        <span style={{ fontSize: 11, color: 'var(--stone)', fontFamily: 'sans-serif', marginLeft: 4 }}>/ {d.weight}</span>
                      ) : d.is_weight ? (
                        <span style={{ fontSize: 10, color: 'var(--stone)', fontFamily: 'sans-serif', marginLeft: 4 }}>/ 100мл/г</span>
                      ) : null}
                    </td>
                    <td style={{ padding: '12px 16px' }}>
                      <span style={{ fontSize: 11, fontWeight: 500, padding: '3px 10px', borderRadius: 20, background: d.is_active ? 'var(--success2)' : 'var(--danger2)', color: d.is_active ? 'var(--success)' : 'var(--danger)' }}>
                        {d.is_active ? 'Активна' : 'Вимкнена'}
                      </span>
                    </td>
                    <td style={{ padding: '12px 16px' }}>
                      <div style={{ display: 'flex', gap: 8 }}>
                        <button onClick={() => openEdit(d)} style={{ padding: '6px 12px', borderRadius: 8, border: '1px solid var(--border)', background: 'transparent', fontSize: 12, color: 'var(--ink)', cursor: 'pointer' }}>Редагувати</button>
                        <button onClick={() => handleDelete(d.id)} style={{ padding: '6px 12px', borderRadius: 8, border: '1px solid var(--danger2)', background: 'var(--danger2)', fontSize: 12, color: 'var(--danger)', cursor: 'pointer' }}>Видалити</button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}

      {/* Modal */}
      {modal && (
        <div className="fade-in" style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100 }} onMouseDown={e => e.target === e.currentTarget && setModal(false)}>
          <div className="fade-up" style={{ background: '#fff', borderRadius: 20, padding: '28px 28px', width: 500, maxHeight: '90vh', overflowY: 'auto' }}>
            <div style={{ fontFamily: "'Fraunces', serif", fontSize: 20, marginBottom: 22 }}>
              {editId ? 'Редагувати страву' : 'Нова страва'}
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
              <div>
                <label style={{ fontSize: 11, color: 'var(--stone)', fontWeight: 500, display: 'block', marginBottom: 5, textTransform: 'uppercase', letterSpacing: '1px' }}>
                  {isLunch ? 'День тижня' : 'Назва'}
                </label>
                {isLunch ? (
                  <select 
                    value={form.name} 
                    onChange={e => setForm(f => ({ ...f, name: e.target.value }))} 
                    style={inputStyle}
                  >
                    <option value="">Оберіть день...</option>
                    {DAYS.map(day => <option key={day} value={day}>{day}</option>)}
                  </select>
                ) : (
                  <input 
                    value={form.name} 
                    onChange={e => setForm(f => ({ ...f, name: e.target.value }))} 
                    style={inputStyle} 
                    placeholder="Назва страви" 
                  />
                )}
              </div>

              <div>
                <label style={{ fontSize: 11, color: 'var(--stone)', fontWeight: 500, display: 'block', marginBottom: 5, textTransform: 'uppercase', letterSpacing: '1px' }}>Опис</label>
                <textarea value={form.description} onChange={e => setForm(f => ({ ...f, description: e.target.value }))} style={{ ...inputStyle, height: 80, resize: 'vertical' }} placeholder="Склад та опис страви" />
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12 }}>
                <div>
                  <label style={{ fontSize: 11, color: 'var(--stone)', fontWeight: 500, display: 'block', marginBottom: 5, textTransform: 'uppercase', letterSpacing: '1px' }}>Ціна (₴)</label>
                  <input type="number" value={form.price} onChange={e => setForm(f => ({ ...f, price: e.target.value }))} style={inputStyle} placeholder="250" />
                </div>
                <div>
                  <label style={{ fontSize: 11, color: '#e74c3c', fontWeight: 600, display: 'block', marginBottom: 5, textTransform: 'uppercase', letterSpacing: '1px' }}>Акція (₴)</label>
                  <input type="number" value={form.discount_price} onChange={e => setForm(f => ({ ...f, discount_price: e.target.value }))} style={{...inputStyle, borderColor: form.discount_price ? '#e74c3c' : 'var(--border)'}} placeholder="нова ціна" />
                </div>
                <div>
                  <label style={{ fontSize: 11, color: 'var(--stone)', fontWeight: 500, display: 'block', marginBottom: 5, textTransform: 'uppercase', letterSpacing: '1px' }}>Вага / Об'єм</label>
                  <input type="text" value={form.weight || ''} onChange={e => setForm(f => ({ ...f, weight: e.target.value }))} style={inputStyle} placeholder="напр: 300 г" />
                </div>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                <div>
                  <label style={{ fontSize: 11, color: 'var(--stone)', fontWeight: 500, display: 'block', marginBottom: 5, textTransform: 'uppercase', letterSpacing: '1px' }}>Категорія</label>
                  <select 
                    value={form.category_id} 
                    onChange={e => {
                      const newCat = e.target.value;
                      setForm(f => ({ ...f, category_id: newCat, name: String(newCat) === '8' ? '' : f.name }));
                    }} 
                    style={inputStyle}
                  >
                    {CATEGORIES.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
                  </select>
                </div>
                <div>
                  <label style={{ fontSize: 11, color: 'var(--stone)', fontWeight: 500, display: 'block', marginBottom: 5, textTransform: 'uppercase', letterSpacing: '1px' }}>Бейдж</label>
                  <select value={form.badge} onChange={e => setForm(f => ({ ...f, badge: e.target.value }))} style={inputStyle}>
                    {Object.entries(BADGE_LABELS).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
                  </select>
                </div>
              </div>

              <div>
                <label style={{ fontSize: 11, color: 'var(--stone)', fontWeight: 500, display: 'block', marginBottom: 5, textTransform: 'uppercase', letterSpacing: '1px' }}>Фото страви</label>

                {/* Прев'ю: нове фото АБО поточне (якщо не позначене на видалення) */}
                {(previewUrl || (currentImage && !removeImage)) && (
                  <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 10 }}>
                    <div style={{ width: 64, height: 64, borderRadius: 10, overflow: 'hidden', border: '1px solid var(--border)', background: 'var(--sand2)', flexShrink: 0 }}>
                      <img
                        src={previewUrl ? previewUrl : (currentImage.startsWith('http') ? currentImage : `https://restaurant-backend-pi-nine.vercel.app${currentImage}`)}
                        alt="прев'ю"
                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                      />
                    </div>
                    <div style={{ fontSize: 12, color: 'var(--stone)', lineHeight: 1.4 }}>
                      {previewUrl ? 'Нове фото — замінить старе після збереження' : 'Поточне фото'}
                    </div>
                    <button
                      type="button"
                      onClick={() => { if (image) { setImage(null); } else { setRemoveImage(true); } }}
                      style={{ marginLeft: 'auto', padding: '6px 12px', borderRadius: 8, border: '1px solid var(--danger2)', background: 'var(--danger2)', color: 'var(--danger)', fontSize: 12, cursor: 'pointer', whiteSpace: 'nowrap' }}
                    >
                      {image ? 'Скасувати' : 'Видалити фото'}
                    </button>
                  </div>
                )}

                {/* Позначили фото на видалення */}
                {removeImage && !image && (
                  <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 10, fontSize: 12, color: 'var(--danger)' }}>
                    Фото буде видалено після збереження.
                    <button type="button" onClick={() => setRemoveImage(false)} style={{ padding: '6px 12px', borderRadius: 8, border: '1px solid var(--border)', background: 'transparent', color: 'var(--stone)', fontSize: 12, cursor: 'pointer' }}>Скасувати</button>
                  </div>
                )}

                <input
                  type="file"
                  accept="image/*"
                  onChange={e => { setImage(e.target.files[0] || null); setRemoveImage(false); }}
                  style={{ ...inputStyle, padding: '8px 13px' }}
                />
                <div style={{ fontSize: 11, color: 'var(--stone)', marginTop: 5, lineHeight: 1.4 }}>
                  {editId
                    ? 'Якщо не чіпати це поле — фото залишиться незмінним. Обери файл, щоб замінити, або натисни «Видалити фото».'
                    : 'Обери файл, щоб додати фото страви.'}
                </div>
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginTop: 5, background: '#f8f9fa', padding: 12, borderRadius: 8, border: '1px solid var(--border)' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  <input type="checkbox" id="active" checked={form.is_active} onChange={e => setForm(f => ({ ...f, is_active: e.target.checked }))} style={{ width: 16, height: 16, cursor: 'pointer' }} />
                  <label htmlFor="active" style={{ fontSize: 13, color: 'var(--ink)', cursor: 'pointer' }}>Страва активна (відображається в меню)</label>
                </div>
                
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  <input type="checkbox" id="weight" checked={form.is_weight} onChange={e => setForm(f => ({ ...f, is_weight: e.target.checked }))} style={{ width: 16, height: 16, cursor: 'pointer' }} />
                  <label htmlFor="weight" style={{ fontSize: 13, color: 'var(--ink)', cursor: 'pointer' }}>Продається на вагу (вказано ціну за 100мл/г)</label>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginTop: 4, paddingTop: 10, borderTop: '1px solid #e2e8f0' }}>
                  <input type="checkbox" id="preorder" checked={form.is_preorder} onChange={e => setForm(f => ({ ...f, is_preorder: e.target.checked }))} style={{ width: 16, height: 16, cursor: 'pointer', accentColor: '#d32f2f' }} />
                  <label htmlFor="preorder" style={{ fontSize: 13, color: '#d32f2f', fontWeight: 600, cursor: 'pointer' }}>Червона страва (Передзамовлення за 2 дні)</label>
                </div>
              </div>

              <div style={{ display: 'flex', gap: 10, marginTop: 6 }}>
                <button onClick={() => setModal(false)} style={{ flex: 1, padding: '11px', borderRadius: 10, border: '1px solid var(--border)', background: 'transparent', fontSize: 13, color: 'var(--stone)', cursor: 'pointer' }}>Скасувати</button>
                <button onClick={handleSave} disabled={saving} style={{ flex: 2, padding: '11px', borderRadius: 10, border: 'none', background: 'var(--ink)', color: '#fff', fontSize: 13, fontWeight: 500, cursor: 'pointer' }}>
                  {saving ? 'Збереження...' : editId ? 'Зберегти зміни' : 'Додати страву'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
